var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHollowCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_10",
    "data-name": "Ellipse 10",
    fill: "#fff",
    stroke: "#000",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 13,
    cy: 13,
    r: 13,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 13,
    cy: 13,
    r: 12,
    fill: "none"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHollowCircle);
export default __webpack_public_path__ + "static/media/hollow_circle.752a844f3e98223f59594dd005394d0c.svg";
export { ForwardRef as ReactComponent };